export const RELEVANT_SPECIALISTS_MODAL_NAME = 'relevantSpecialists';
